import { Nav } from "@/components/Nav";
import { SiteFooter } from "@/components/SiteFooter";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-brand-paper text-brand-black flex flex-col">
      <Nav />
      <main className="flex-1 pt-36 pb-24 px-6">
        <div className="max-w-2xl mx-auto">
          <p className="font-mono text-[11px] font-bold tracking-[0.28em] text-brand-red uppercase">
            Privacy
          </p>
          <h1 className="mt-4 font-serif font-black text-display-md text-brand-black">
            What we collect.
          </h1>
          <div className="mt-12 space-y-7 text-lg text-brand-ink leading-relaxed">
            <p>
              We collect three things: your email address, the teams you
              subscribe to, and the timestamps of editions we send you. That's
              it. We use this only to send you the recaps you signed up for.
            </p>
            <p>
              Stripe handles all payment data. We never see your card number,
              expiration, or CVV. They store your billing address and the last
              four digits of your card.
            </p>
            <p>
              We don't share your information with third parties for marketing.
              We don't sell your data. We don't run analytics or tracking pixels
              in the emails.
            </p>
            <p>
              If you want your data deleted, reply to any recap and we'll remove
              your subscriber row and stop sending. Stripe's record of your past
              charges sticks around for tax and accounting purposes.
            </p>
            <p>
              Reply to any email with privacy questions and we'll answer.
            </p>
            <p className="text-sm text-brand-muted pt-8 border-t border-brand-rule">
              Last updated: April 2026.
            </p>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
